import { memo } from 'react';
import { Link } from 'react-router-dom';
import { FiStar } from 'react-icons/fi';
import { useCurrency } from '../../context/CurrencyContext';
import { getBookImage, handleBookImageError } from '../../utils';
import StockOverlay from '../common/StockOverlay';

const RelatedProducts = ({ items = [], title = 'Products related to this item' }) => {
  const { formatBookPrice } = useCurrency();
  if (!items || items.length === 0) return null;

  return (
    <section className="mt-8">
      <h2 className="text-lg font-bold text-black mb-4">{title}</h2>
      <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 list-none">
        {items.map((p) => (
          <li key={p.id}>
            <Link
              to={`/book/${p.id}`}
              className="block bg-white border border-gray-200 rounded p-2 hover:shadow-md transition"
            >
              <figure className="relative h-32 overflow-hidden rounded mb-2">
                <img
                  src={getBookImage(p.image)}
                  onError={handleBookImageError}
                  alt={p.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover bg-gray-100"
                />
                <StockOverlay stock={p.stock} compact />
              </figure>
              <p className="text-xs text-black line-clamp-2 mb-1">{p.title}</p>
              <p className="flex items-center gap-1 text-[11px] text-black mb-1">
                <FiStar className="text-orange-400 fill-orange-400 text-xs" />
                {p.rating}
              </p>
              <p className="text-sm font-semibold text-black">{formatBookPrice(p)}</p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default memo(RelatedProducts);
